import React from 'react';

interface TokenIconProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const TokenIcon: React.FC<TokenIconProps> = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
  };

  return (
    <div className={`${sizeClasses[size]} relative flex items-center justify-center ${className}`}>
      {/* Circle background */}
      <div className="absolute inset-0 rounded-full bg-zinc-800 dark:bg-zinc-700 shadow-sm" />
      {/* Teal X */}
      <svg 
        className="relative z-10 w-[60%] h-[60%]" 
        viewBox="0 0 24 24" 
        fill="none"
      >
        <path 
          d="M18 6L6 18M6 6l12 12" 
          stroke="#14B8A6" 
          strokeWidth="4" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default TokenIcon;







